/** Fiskaly 设置页各业务卡片与加载骨架的展示状态。 */
export interface FiskalySettingVisibility {
    /** 是否展示商家声明卡片。 */
    showAgreement: boolean;
    /** 是否展示责任证书卡片。 */
    showResponsibilityDeclaration: boolean;
    /** 加载阶段展示的骨架卡片数量。 */
    skeletonCount: number;
}

/**
 * 根据税务区域返回 Fiskaly 设置页的展示规则。
 * @param showVerifactu - 当前餐厅是否属于 Verifactu 区域
 * @param showTicketBAI - 当前餐厅是否属于 TicketBAI 区域
 * @returns 页面业务卡片和骨架屏的展示状态
 */
export function getFiskalySettingVisibility(
    showVerifactu: boolean,
    showTicketBAI: boolean,
): FiskalySettingVisibility {
    return {
        showAgreement: showVerifactu || showTicketBAI,
        showResponsibilityDeclaration: showVerifactu,
        skeletonCount: 1,
    };
}
